module.exports = __webpack_public_path__ + "static/img/biobank-5.aa07989f6803c769eba4b4fe2983d1bd.png";